// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewWorkspace.test.tsx
import { Chat, Users } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import { type AskV2ReviewLeftPane } from "./useAskV2ReviewWorkspace";

import { SlidingSegmentedControl } from "../../components/SlidingSegmentedControl";

export function AskV2ReviewPaneTabs({
  leftPane,
  commentCount,
  onChange,
  "data-testid": testId = "ask-v2-review-pane-tabs",
  testIdPrefix = "ask-v2-review",
  ariaLabel,
}: {
  leftPane: AskV2ReviewLeftPane;
  commentCount: number;
  onChange: (pane: AskV2ReviewLeftPane) => void;
  "data-testid"?: string;
  /** Prefix for the thumb and segment testids when a second toggle is on screen. */
  testIdPrefix?: string;
  /** Overrides the group name when a second switcher is on screen. */
  ariaLabel?: string;
}) {
  const { t } = useTranslation("ui");

  return (
    <SlidingSegmentedControl
      value={leftPane}
      onChange={onChange}
      ariaLabel={ariaLabel ?? t("askV2.review.paneTabsLabel")}
      data-testid={testId}
      thumbTestId={`${testIdPrefix}-pane-tabs-thumb`}
      items={[
        {
          id: "feed",
          testId: `${testIdPrefix}-tab-feed`,
          content: (
            <>
              <Users size={16} aria-hidden="true" />
              {t("askV2.review.feedTab")}
            </>
          ),
        },
        {
          id: "comments",
          testId: `${testIdPrefix}-tab-comments`,
          content: (
            <>
              <Chat size={16} aria-hidden="true" />
              {t("askV2.review.commentsTab", { count: commentCount })}
            </>
          ),
        },
      ]}
    />
  );
}
